import {URLS} from "../constants";
import BaseForm from "./baseform";

export default class OrderForm extends BaseForm {
	defaultOptions() {
		return {
			ajaxUrl: URLS.ORDER,
			container: ""
		}
	}

	getLoadComponentParams() {
		return {
			personTypeId: this.getCurrentPersonType(),
		};
	}

	getCurrentPersonType() {
		return $("[name=PERSON_TYPE]").val();
	}
}